import { executeRequest, Request, Response } from '@jfs/network'
import { Config } from 'react-native-config'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: Response) => {
  if (data?.data?.responseStatus?.code === '000') {
    const categoryObj: any = {}
    const categoryGroup = []
    data?.data?.responseObject?.map((item: any) => {
      const categoryType = item?.categoryGroup.categoryType
      const catetoryList = item?.categoryGroup?.catetoryList
      categoryGroup.push({ categoryType: categoryType, categoryList: catetoryList }) // TODO: label name should be corrected at backend
      categoryObj[categoryType] = catetoryList ?? []
    })
    // TODO: remove categoryObj and make it dynamic render when order-id is introduced in the api response
    return { response: categoryObj, category: categoryGroup }
  } else {
    const errorMsg = {
      errorCode: data?.data?.error?.code,
      errorMessage: data?.data?.error?.message,
    }
    throw errorMsg
  }
}

const returnBody = () => {
  return {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      //CONFIRM WITH BACKEND
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
    },
  }
}

export const fetchBillerCategoriesV2 = (tokens, userAccessToken) => {
  const config = sitConfig(tokens)
  //config.baseUrl = Config.REACT_APP_JFS_BASE_URL
  const request: Request<{}> = {
    apiPath: APIEndPoints.getCategoryListV2,
    method: 'POST',
    body: returnBody(),
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    //headers: { ...getHeader() },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
